import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, DownloadIcon } from 'lucide-react';
const KIT_URL = 'https://digital-solvex-ar.myshopify.com/cart/48681186394369:1';
const HERO_IMG = 'https://cdn.shopify.com/s/files/1/0815/5253/9905/files/IMAGEN_6_Kit_Completo_Hero_Image_para_la_Landing__1_1.jpg?v=1777410949';
const stats = [{
  value: '+800',
  label: 'Vendedores'
}, {
  value: '5',
  label: 'Productos'
}, {
  value: '90',
  label: 'Días al 2X'
}, {
  value: '100%',
  label: 'Legal'
}];
const trustItems = [{
  icon: LockIcon,
  text: 'Pago seguro MP'
}, {
  icon: DownloadIcon,
  text: 'Descarga inmediata'
}];
const paymentMethods = ['MP', 'VISA', 'MC', 'AMEX', 'DÉBITO', 'TRANSF.'];
export function HeroSection() {
  return <section className="relative bg-navy-mid dot-grid pt-28 md:pt-32 pb-16 md:pb-24 overflow-hidden" data-id="element-108">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-109">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-110">

          {/* Left Column */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.65
        }} data-id="element-111">
            <span className="inline-flex items-center gap-2 bg-teal/15 text-teal border border-teal/30 px-4 py-1.5 rounded-full text-sm font-semibold mb-6" data-id="element-112">
              <span className="w-2 h-2 rounded-full bg-teal animate-pulse" data-id="element-113" />
              +800 vendedores de ML ya lo usan
            </span>

            <h1 className="font-display font-extrabold text-4xl md:text-5xl lg:text-6xl leading-tight mb-6" data-id="element-114">
              <span className="text-white" data-id="element-115">¿Sabés cuánto ganás </span>
              <span className="gold-shine" data-id="element-116">realmente</span>
              <span className="text-white" data-id="element-117"> por cada venta en Mercado Libre?</span>
            </h1>

            <p className="text-white/60 text-lg md:text-xl leading-relaxed mb-8 max-w-xl" data-id="element-118">
              El sistema completo para calcular tu ganancia real, controlar tu
              stock y duplicar tu rentabilidad en 90 días — todo en un solo Kit.
            </p>

            {/* Stats Row */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8" data-id="element-119">
              {stats.map(stat => <div key={stat.label} className="bg-white/5 backdrop-blur-sm rounded-xl p-4 text-center border border-white/5" data-id="element-120">
                  <div className="text-gold font-display font-bold text-2xl" data-id="element-121">{stat.value}</div>
                  <div className="text-white/50 text-sm mt-1" data-id="element-122">{stat.label}</div>
                </div>)}
            </div>

            {/* CTA */}
            <a href={KIT_URL} className="btn-gold block w-full text-center text-lg py-4 rounded-xl font-extrabold mb-6 no-underline" data-id="element-123">
              Quiero el Kit Completo por $62.900 →
            </a>

            {/* Trust Strip */}
            <div className="flex items-center gap-6 mb-6" data-id="element-124">
              {trustItems.map(item => <div key={item.text} className="flex items-center gap-2 text-white/50 text-sm" data-id="element-125">
                  <item.icon className="w-4 h-4 text-gold shrink-0" data-id="element-126" />
                  <span data-id="element-127">{item.text}</span>
                </div>)}
            </div>

            {/* Payment Methods */}
            <div className="border-t border-white/[0.06] pt-5" data-id="element-128">
              <p className="text-[10px] text-white/30 uppercase tracking-widest mb-3" data-id="element-129">
                Aceptamos todos los medios de pago
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-130">
                {paymentMethods.map(method => <span key={method} className="bg-white/5 text-white/40 text-xs px-3 py-1 rounded-full border border-white/10" data-id="element-131">
                    {method}
                  </span>)}
              </div>
            </div>
          </motion.div>

          {/* Right Column — imagen real */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.75,
          delay: 0.2
        }} className="relative flex items-center justify-center" data-id="element-132">
            {/* Glow */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-133">
              <div className="w-4/5 h-4/5 bg-gold/10 rounded-full blur-3xl" data-id="element-134" />
            </div>

            <div className="relative z-10 w-full max-w-sm md:max-w-none" data-id="element-135">
              {/* Badges flotantes */}
              <div className="absolute top-4 right-4 z-20 bg-gold text-navy-dark font-display text-sm font-extrabold px-3 py-1.5 rounded-full shadow-lg shadow-gold/30" data-id="element-136">
                $62.900 hoy
              </div>
              <div className="absolute top-14 right-4 z-20 bg-teal text-white text-xs font-bold px-2.5 py-1.5 rounded-full" data-id="element-137">
                Ahorrás $71.600
              </div>

              <img src={HERO_IMG} alt="Kit ML Rentable — Sistema completo para vendedores de Mercado Libre" className="w-full rounded-2xl shadow-2xl" style={{
              display: 'block'
            }} data-id="element-138" />
            </div>
          </motion.div>

        </div>
      </div>
    </section>;
}